"use client";

import { logPageView } from "@/lib/analytics";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    if (pathname && pathname !== previousPath.current) {
      logPageView(pathname);
      previousPath.current = pathname;
    }
  }, [pathname]);

  return <>{children}</>;
}
